import { post,  get }  from '@/axios/method';

// 获取手机验证码 [易聪林](http://yapi.dev.anoah.com/mock/1225/api/dm/clue/inquiry/sendPhoneVerifyCode)
export const sendPhoneVerifyCode = (data) => post('/api/dm/clue/inquiry/sendPhoneVerifyCode', data);

// 获取推荐导购信息 [易聪林](http://yapi.dev.anoah.com/mock/1225/api/dm/clue/inquiry/getRecommendUserInfo)
export const getRecommendUserInfo = (data) => post('/api/dm/clue/inquiry/getRecommendUserInfo', data);

// 公益链接询价 [易聪林](http://yapi.dev.anoah.com/mock/1225/api/dm/clue/inquiry/welfareApply)
export const welfareApply = (data) => post('/api/dm/clue/inquiry/welfareApply', data);
